import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createVNode("h2", null, "Events")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-light-primary"
}
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Download Report ")
const _hoisted_7 = { class: "card-body py-0" }
const _hoisted_8 = {
  class: "\n          table\n          align-middle\n          table-row-dashed\n          fs-6\n          text-gray-600\n          fw-bold\n          gy-5\n        ",
  id: "kt_table_customers_events"
}
const _hoisted_9 = { class: "pe-0 text-gray-600 text-end min-w-200px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", {
    class: `card pt-4 ${_ctx.cardClasses}`
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("button", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/files/fil021.svg" })
          ]),
          _hoisted_6
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("table", _hoisted_8, [
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.events, (event, i) => {
            return (_openBlock(), _createBlock("tr", { key: i }, [
              _createVNode("td", {
                class: "min-w-400px",
                innerHTML: event.event
              }, null, 8, ["innerHTML"]),
              _createVNode("td", _hoisted_9, _toDisplayString(event.date), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 2))
}